import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-calculator-withdraw-ves',
  templateUrl: './calculator-withdraw-ves.component.html',
  styleUrls: ['./calculator-withdraw-ves.component.sass'],
})
export class CalculatorWithdrawVesComponent {
  readonly MIN_VES_WITHDRAW = 6000;
  // Comisión Aguacate 0.3%: se descuenta del monto a enviar al beneficiario.
  // Debe coincidir con el backend (RETIRO_VES_COMISION_RATE en wallet-ves.service.ts).
  readonly COMISION_RATE = 0.003;
  public valorRetiro: number = 0;
  public valorBalanceFinal: number = 0;

  @Input()
  public saldoActual: number = 0;

  @Output()
  public changeStep = new EventEmitter<number>();

  @Output()
  public montoRetiroEmit = new EventEmitter<number>();

  constructor() {
    this.valorBalanceFinal = this.saldoActual;
    this.valorRestante = this.saldoActual.toLocaleString('es-VE');
  }

  get valorARetiro(): string {
    return this.valorRetiro === 0
      ? ''
      : this.valorRetiro.toLocaleString('es-VE');
  }

  set valorARetiro(val: string) {
    if (val === '') {
      this.valorRetiro = 0;
    } else {
      this.valorRetiro = parseFloat(val.replace(/\./g, '').replace(',', '.'));
    }
  }

  get valorRestante(): string {
    return this.valorBalanceFinal.toLocaleString('es-VE');
  }
  set valorRestante(val: string) {
    if (val === '') {
      this.valorBalanceFinal = 0;
    } else {
      this.valorBalanceFinal = parseFloat(val.replace(/\./g, '').replace(',', '.'));
    }
  }

  emitChangeStep(): void {
    this.changeStep.emit(2);
    this.montoRetiroEmit.emit(this.valorRetiro);
  }

  maxValAvailable(): void {
    if (this.saldoActual > 0) {
      this.valorRetiro = Math.trunc(this.saldoActual * 100) / 100;
      this.balanceLeft();
    }
  }

  clearVal(): void {
    this.valorARetiro = '0';
    this.valorRestante = '0';
    this.valorRetiro = 0;
    this.valorBalanceFinal = this.saldoActual;
  }

  balanceLeft(): void {
    this.valorBalanceFinal = this.saldoActual - this.valorRetiro;
    this.valorRestante = this.valorBalanceFinal.toLocaleString('es-VE');
  }

  // Comisión 0.3% (mismo redondeo que el backend: 2 decimales)
  get comisionVes(): number {
    return Math.round(this.valorRetiro * this.COMISION_RATE * 100) / 100;
  }

  // Monto neto que recibe el beneficiario = monto retirado - comisión
  get montoRecibido(): number {
    return Math.round((this.valorRetiro - this.comisionVes) * 100) / 100;
  }

  get isBelowMinimum(): boolean {
    return this.valorRetiro > 0 && this.valorRetiro < this.MIN_VES_WITHDRAW;
  }

  get isValidWithdrawAmount(): boolean {
    return this.valorRetiro >= this.MIN_VES_WITHDRAW && this.valorRetiro <= this.saldoActual;
  }

  soloNumeros(event: KeyboardEvent) {
    const char = event.key;
    if (!char.match(/[0-9.,]/)) {
      event.preventDefault();
    }
  }
}
